
import type { Offer, ProductOffer } from '~/type/product/Product';
interface Props {
  offer: ProductOffer;
}
const __sfc_main = {};
__sfc_main.props = {
  offer: {
    key: "offer",
    required: true,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  function onSelect(el: Offer) {
    emit('change', el);
  }
  return {
    onSelect
  };
};
export default __sfc_main;
